<script>
    let { yScale, ticks = [], chartwidth = 400, unit = '', part = 'both' } = $props();

    const topTick = $derived(ticks.length ? Math.max(...ticks) : 0);

    const label = tick => {
        let s = tick.toLocaleString();
        if (tick === topTick && unit) s += ` ${unit}`;
        return s;
    };

    // $inspect(ticks);
</script>

<g class="y-axis">
    {#if part === 'grid' || part === 'both'}
        {#each ticks as tick}
            <line
                class="y-tick"
                x1={0}
                x2={chartwidth}
                y1={yScale(tick)}
                y2={yScale(tick)}
            ></line>
        {/each}
    {/if}

    {#if part === 'labels' || part === 'both'}
        {#each ticks as tick}
            <text class="tick-text halo" x={0} y={yScale(tick) - 4}>{label(tick)}</text>
            <text class="tick-text" x={0} y={yScale(tick) - 4}>{label(tick)}</text>
        {/each}
    {/if}
</g>

<style lang="scss">
    @import '@/styles/variables';

    .tick-text {
        font-size: 11px;
        fill: #666;
        pointer-events: none;

        &.halo {
            fill: #fff;
            stroke: #fff;
            stroke-width: 3;
            stroke-linejoin: round;
        }
    }

    .y-tick {
        stroke: $gray4;
        stroke-width: 1;
    }
</style>
